import {
    ClientErrorCodes,
    ErrorTranslationKeys,
} from '@models';

export class TranslatableError extends Error {
    constructor(
        public translationKey: ErrorTranslationKeys,
        public supportCode: ClientErrorCodes = ClientErrorCodes.UnknownUiError,
    ) {
        // 'Error' breaks prototype chain here.
        super(`${translationKey} (#${supportCode})`);

        // Restore prototype chain.
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
